export default {
  headerContent: {
    title: 'Sompo Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta DASK',
    description: {
      title:
        'Sompo Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek?',
      content: [
        'Sompo Sigorta DASK sigortası deprem sonucunda oluşan maddi haddi hasarları poliçede yazan limitler dahilinde güvence altına almaktadır.',
        'Sompo Sigorta’dan deprem sigortası satın alarak deprem sonucu hasarların sebep olacağı maddi kayıpları güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Zorunlu Deprem Sigortası Teminatları Neler?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası teminatları;',
          subList: [
            'Deprem Sonrası İnfilak',
            'Deprem Sonrası Maddi Zarar',
            'Deprem Sonrası Tsunami',
            'Deprem Sonrası Yangın',
            'Deprem Sonrası Yer Kayması teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
